import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
import { CTAButton } from './CTAButton';
const bonuses = [{
  num: 1,
  title: 'Guía Ingredientes Natural Pro',
  desc: 'Aceites esenciales, arcillas, hierbas y mantecas. Sabés exactamente para qué sirve cada uno y cómo combinarlos para hacer <strong class="text-brand-brown">jabones Premium de alto valor.</strong>',
  value: '19.99',
  image: 'https://cdn.magicpatterns.com/uploads/aoN6juvCd4sAeq1My8Y5zL/20251223_0953_Guia_de_Ingredientes_Naturales_simple_compose_01kd5mazwefhvaez2f616ajv1x.png'
}, {
  num: 2,
  title: 'Manual Curado Perfecto',
  desc: 'El proceso que más falla en principiantes. Tiempos exactos, condiciones ideales y señales de que tu jabón está listo para vender. <strong class="text-brand-brown">Nunca más un lote perdido.</strong>',
  value: '14.99',
  image: 'https://cdn.magicpatterns.com/uploads/jGymuA1bj1GSYjPCCnBvAM/20251223_0957_Conservacion_y_Curado_Guia_simple_compose_01kd5mgm5yfj1sntzrvx2dr1sz.png'
}, {
  num: 3,
  title: '50 Recetas Rápidas',
  desc: '50 recetas adicionales listas para hacer y vender. Desde jabones clásicos hasta creaciones originales con ingredientes accesibles. <strong class="text-brand-brown">Tu catálogo completo para empezar a vender desde el día uno.</strong>',
  value: '24.99',
  image: 'https://cdn.magicpatterns.com/uploads/71a3zFky46tewnYtvw7LvX/20251223_0951_Recetas_de_Jabones_Funcionales_simple_compose_01kd5m6kjweb0apfpq1876smeb.png'
}];
export function BonusSection() {
  return <section className="py-14 px-4 bg-brand-amber-light relative overflow-hidden" data-id="element-16">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-17">
        <div className="absolute -top-24 -left-24 w-96 h-96 bg-brand-gold/15 rounded-full blur-3xl" data-id="element-18" />
        <div className="absolute bottom-0 right-0 w-[600px] h-[600px] bg-brand-gold/10 rounded-full blur-3xl" data-id="element-19" />
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-20">
        <div className="text-center mb-10" data-id="element-21">
          <img src="https://cdn.magicpatterns.com/uploads/umieJhPgbBy2hsLUUMhtnu/20260224_1612_Image_Generation_simple_compose_01kj8h0nzgfqgaxmhqgpcj2y3p.png" alt="Mega Pack - Aprende a hacer tus Jabones Artesanales" className="w-full max-w-md mx-auto rounded-2xl shadow-lg mb-6" data-id="element-22" />
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-black mb-4 text-brand-brown tracking-tight" data-id="element-23">
            Bonos de regalo incluidos hoy
          </h2>
          <p className="text-xl text-brand-brown font-bold mb-2 font-playfair italic" data-id="element-24">
            Comprás los 6 Tomos y recibís estos{' '}
            <mark data-id="element-25">3 extras sin costo adicional</mark>
          </p>
          <p className="text-base md:text-lg text-brand-brown/70 font-medium max-w-2xl mx-auto" data-id="element-26">
            Cada bono fue diseñado para resolver el obstáculo que viene justo
            después de terminar los tomos.
          </p>
        </div>

        <div className="space-y-4 mb-10" data-id="element-27">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white rounded-2xl p-5 md:p-6 shadow-xl border-l-[10px] border-brand-gold flex flex-col md:flex-row gap-5 items-start md:items-center relative overflow-hidden" data-id="element-28">
              <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-brand-amber-light/50 to-transparent rounded-bl-full -z-10" data-id="element-29" />

              {!bonus.image && <div className="w-16 h-16 shrink-0 bg-gradient-to-br from-brand-amber-light to-brand-gold/20 rounded-xl flex items-center justify-center text-3xl font-black text-brand-gold font-playfair shadow-inner border border-brand-gold/30" data-id="element-30">
                  #{bonus.num}
                </div>}
              <div className="flex-1" data-id="element-31">
                {bonus.image && <img src={bonus.image} alt={bonus.title} className="w-full max-w-xs rounded-xl shadow-md mb-3" data-id="element-32" />}
                <div className="text-xs font-bold text-brand-gold uppercase tracking-widest mb-0.5" data-id="element-33">
                  Bono #{bonus.num}
                </div>
                <h3 className="text-xl md:text-2xl font-black mb-2 leading-tight" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-brand-brown/80 text-[15px] leading-relaxed" dangerouslySetInnerHTML={{
              __html: bonus.desc
            }} data-id="element-35" />
              </div>
              <div className="shrink-0 w-full md:w-auto text-center bg-brand-cream px-6 py-4 rounded-xl border-2 border-brand-gold/30 shadow-sm" data-id="element-36">
                <div className="text-xs font-bold text-brand-brown/50 uppercase tracking-wider mb-1" data-id="element-37">
                  Valor Real
                </div>
                <div className="text-lg text-brand-brown/40 line-through mb-1 font-medium" data-id="element-38">
                  US${bonus.value}
                </div>
                <div className="text-xl font-black text-solution-green flex items-center justify-center gap-2 bg-green-50 py-1.5 px-3 rounded-lg" data-id="element-39">
                  <CheckIcon className="w-5 h-5 stroke-[3]" data-id="element-40" /> GRATIS
                </div>
              </div>
            </motion.div>)}
        </div>

        {/* Total Value Box */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-7 md:p-10 shadow-2xl border-2 border-brand-gold/40 text-center relative overflow-hidden" data-id="element-41">
          <div className="absolute top-0 left-0 w-full h-3 bg-gradient-to-r from-brand-gold via-[#FDE68A] to-brand-gold" data-id="element-42" />

          <div className="absolute -top-1 -right-1 md:top-4 md:right-4 bg-brand-red text-white text-xs md:text-sm font-black py-1.5 px-3 md:py-2 md:px-4 rounded-lg shadow-lg -rotate-3 border border-white/20 z-20" data-id="element-43">
            AHORRÁS $67.000+
          </div>

          <h3 className="text-2xl md:text-3xl font-black mb-6 font-playfair mt-4 md:mt-0" data-id="element-44">
            Todo lo que recibís hoy
          </h3>

          <div className="space-y-3 max-w-lg mx-auto mb-8 text-left bg-brand-cream/50 p-5 md:p-6 rounded-2xl border border-brand-brown/5" data-id="element-45">
            <div className="flex justify-between items-center border-b border-brand-brown/10 pb-3" data-id="element-46">
              <span className="font-bold text-base" data-id="element-47">
                6 Tomos Mega Pack Completo
              </span>
              <span className="text-brand-brown/50 font-medium text-base" data-id="element-48">
                $39.990
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-brown/10 pb-3" data-id="element-49">
              <span className="font-bold text-base" data-id="element-50">
                Clases Online de Por Vida
              </span>
              <span className="text-brand-brown/50 font-medium text-base" data-id="element-51">
                $15.000
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-brown/10 pb-3" data-id="element-52">
              <span className="font-bold text-brand-gold text-base flex items-center gap-2" data-id="element-53">
                <CheckIcon className="w-4 h-4" data-id="element-54" /> BONO 1 · Guía Ingredientes
              </span>
              <span className="text-brand-brown/40 line-through font-medium text-base" data-id="element-55">
                $19.99
              </span>
            </div>
            <div className="flex justify-between items-center border-b border-brand-brown/10 pb-3" data-id="element-56">
              <span className="font-bold text-brand-gold text-base flex items-center gap-2" data-id="element-57">
                <CheckIcon className="w-4 h-4" data-id="element-58" /> BONO 2 · Manual Curado
              </span>
              <span className="text-brand-brown/40 line-through font-medium text-base" data-id="element-59">
                $14.99
              </span>
            </div>
            <div className="flex justify-between items-center pb-1" data-id="element-60">
              <span className="font-bold text-brand-gold text-base flex items-center gap-2" data-id="element-61">
                <CheckIcon className="w-4 h-4" data-id="element-62" /> BONO 3 · 50 Recetas Rápidas
              </span>
              <span className="text-brand-brown/40 line-through font-medium text-base" data-id="element-63">
                $24.99
              </span>
            </div>
          </div>

          <div className="mb-6" data-id="element-64">
            <div className="text-brand-brown/60 font-bold text-lg mb-1" data-id="element-65">
              Valor total:{' '}
              <span className="line-through decoration-brand-red/50 decoration-2" data-id="element-66">
                $81.960+
              </span>
            </div>
            <div className="text-base font-black uppercase tracking-[0.2em] text-brand-green mb-3 mt-4 animate-pulse" data-id="element-67">
              Tu precio hoy
            </div>
            <PriceDisplay amount="7.990" fixedSymbol="$" className="text-6xl md:text-7xl text-brand-dark-green font-black tracking-tighter" data-id="element-68" />
          </div>

          <CTAButton className="w-full md:w-[80%] text-xl py-5 shadow-[0_10px_30px_rgba(45,90,61,0.4)] mb-5" data-id="element-69">
            AGREGAR AL CARRITO →
          </CTAButton>

          <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-bold text-brand-brown/70" data-id="element-70">
            <span className="flex items-center gap-1" data-id="element-71">
              <CheckIcon className="w-4 h-4 text-brand-green" data-id="element-72" /> Pago único
            </span>
            <span className="hidden md:inline text-brand-brown/30" data-id="element-73">|</span>
            <span className="flex items-center gap-1" data-id="element-74">
              <CheckIcon className="w-4 h-4 text-brand-green" data-id="element-75" /> Sin cuotas
            </span>
            <span className="hidden md:inline text-brand-brown/30" data-id="element-76">|</span>
            <span className="flex items-center gap-1" data-id="element-77">
              <CheckIcon className="w-4 h-4 text-brand-green" data-id="element-78" /> Acceso eterno
            </span>
            <span className="hidden md:inline text-brand-brown/30" data-id="element-79">|</span>
            <span className="flex items-center gap-1" data-id="element-80">
              <CheckIcon className="w-4 h-4 text-brand-green" data-id="element-81" /> Garantía 30
              días
            </span>
          </div>
        </motion.div>
      </div>
    </section>;
}